import track from 'analytics/track';

/**
 * Calls the Expand Reviews Breakdown event when a user opens the reviews popover in the purchaser of the PDP.
 * @param {string} productCategory the product category of the PDP's respective product
*/
export const showCourierModal = (productCategory) => {
  const trackParams = {
    params: {
      ga: {
        eventAction: `Expand Delivery Message`,
        eventCategory: productCategory,
        eventLabel: `White Glove Delivery`,
        nonInteraction: true,
      },
      heap: {
        eventName: `Expand Delivery Message`,
        properties: {
          category: productCategory,
          deliveryMessage: `Want it Today?`,
        },
      },
    },
  };
  track(trackParams);
};
